export default __webpack_public_path__ + "static/media/lodge-aws-console.ec141448.gif";